var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.9945 12.2148H8.72383C8.30716 12.2148 7.96826 12.5591 7.96826 12.9824C7.96826 13.4065 8.30716 13.7499 8.72383 13.7499H12.9945C13.4112 13.7499 13.7501 13.4065 13.7501 12.9824C13.7501 12.5591 13.4112 12.2148 12.9945 12.2148Z",
    fill: "#3E7EEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73177 3.17795L9.77866 6.44802C9.87628 6.52622 9.89295 6.66973 9.81676 6.7697L5.01906 13.0212C4.71746 13.4074 4.27301 13.6259 3.79681 13.6339L1.17772 13.6662C1.03804 13.6678 0.915811 13.5711 0.884064 13.4324L0.288816 10.8444C0.18564 10.3687 0.288816 9.87691 0.590409 9.49798L5.41192 3.21665C5.4897 3.11587 5.63335 3.09813 5.73177 3.17795Z",
    fill: "#3E7EEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.5905 4.49908L10.8103 5.473C10.7317 5.57217 10.5904 5.5883 10.4928 5.50928C9.5444 4.74175 7.11578 2.77214 6.44196 2.22632C6.34355 2.14569 6.33006 2.00219 6.40942 1.90221L7.16182 0.967793C7.84437 0.0890025 9.03486 0.00837955 9.9952 0.774298L11.0984 1.65309C11.5508 2.00783 11.8524 2.47544 11.9555 2.96724C12.0746 3.50822 11.9476 4.03953 11.5905 4.49908Z",
    fill: "#3E7EEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/edit-blue.66f3b02fab8d8260f2d1c4e5622c4c25.svg";
export { ForwardRef as ReactComponent };